import React, { useState, useEffect, useContext } from 'react';
import { Button, Dialog } from '@material-ui/core';

import StripeCardElement from 'components/StripeCardElement';

import ClearTwoToneIcon from '@material-ui/icons/ClearTwoTone';

import { CircularProgressContext } from 'components/CircularProgressOverlay';
import { NotificationContext } from 'components/NotificationOverlay';

import { notNull, cleanPhone } from 'utils/text';
import { paymentService } from 'services/paymentService';

import { DialogTitleContainer, DialogContentContainer } from './style';

import 'react-credit-cards/es/styles-compiled.css';

const AddPaymentModal = ({ passengerDetail, addPaymentOpen, handleAddPaymentClose, handleRefreshDetail }) => {
  const [stripeClientSecret, setStripeClientSecret] = useState(null);
  const { showCircularProgress, hideCircularProgress } = useContext(CircularProgressContext);
  const { showNotification } = useContext(NotificationContext);

  const getStripeIntents = async () => {
    showCircularProgress('Reading Card on File...');
    const data = await paymentService.get_stripe_customer_intent({
      fname: passengerDetail.first_name,
      lname: passengerDetail.last_name,
      email: passengerDetail.email,
      phone: cleanPhone(passengerDetail.phone),
    });
    hideCircularProgress();

    if (data.data.status === 'SUCCESS') {
      setStripeClientSecret(data.data.data.client_secret);
    }
  };

  useEffect(() => {
    if (addPaymentOpen) {
      getStripeIntents();
    }
  }, [addPaymentOpen]);

  const handleAddStripePayment = async token => {
    if (token) {
      showCircularProgress('Please wait. Saving Payment Method...');
      paymentService
        .add_stripe_payment_to_passenger({
          base_passenger_id: passengerDetail.id,
          fname: passengerDetail.first_name,
          lname: passengerDetail.last_name,
          email: passengerDetail.email,
          phone: cleanPhone(passengerDetail.phone),
          token_val: token?.id,
        })
        .then(({ data }) => {
          hideCircularProgress();
          if (data.status === 'SUCCESS') {
            showNotification('Successfully saved', 'success');
            handleAddPaymentClose(true);
            handleRefreshDetail();
          } else {
            showNotification(`Sorry, Failed to add card: ${data.data.msg}`, 'error');
          }
        });
    }
  };

  return (
    <Dialog
      classes={{ paper: 'modal-content' }}
      fullWidth
      maxWidth="sm"
      open={notNull(addPaymentOpen)}
      onClose={() => handleAddPaymentClose()}
      closeable
    >
      <DialogTitleContainer className="bg-secondary">
        <span>{addPaymentOpen} Payment Card</span>
        <Button
          size="small"
          className="btn-transparent p-2 btn-transition-none"
          onClick={() => handleAddPaymentClose()}
        >
          <span className="btn-wrapper--icon">
            <ClearTwoToneIcon fontSize="small" />
          </span>
        </Button>
      </DialogTitleContainer>
      <DialogContentContainer className="p-0" dividers>
        <div className="dialog-content--wrapper bg-secondary border-0">
          <div className="card-body px-lg-4 py-lg-3">
            <div className="card-body--column w-100">
              <StripeCardElement
                accountId={null}
                options={stripeClientSecret ? { clientSecret: stripeClientSecret } : null}
                handleUpdateStripePayment={handleAddStripePayment}
              />
            </div>
          </div>
        </div>
      </DialogContentContainer>
    </Dialog>
  );
};

export default AddPaymentModal;
